<template>
	<div class="client_details_wrap clearfix">
		<div class="card">
			<div class="card-header" style="background: none; font-size: 20px; font-weight: bold;"><router-link :to="{name:'client_statistics'}">客户统计</router-link> / 统计详情</div>
			<div class="card-body">
				<div class="client_list_box clearfix">
					<div class="infor_box clearf">
						<img :src="customerInfor.avatar==''?'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png':customerInfor.avatar" class="img" />
						<div class="txt">{{customerInfor.username}}</div>
						<el-button :type="!iStop?'success':'info'" v-if="!isshow" class="float-right" @click="clientTop">{{!iStop?'置顶':'取消置顶'}}</el-button>
					</div>
					
					<div class="massage_box clearfix">
						<table class="dataintable">
							<tbody>
								<!-- <div class="tb_hd"><span>沉默活跃</span></div> -->
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">头像</span>
											<img :src="customerInfor.avatar==''?'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png':customerInfor.avatar" class="hd_img" />
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">用户名</span>
											<div class="txt">{{customerInfor.username}}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">注册地区</span>
											<div class="txt">{{customerInfor.city == ''?'暂无':customerInfor.city}}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">创建时间</span>
											<div class="txt">{{customerInfor.regist_date}}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">会员到期时间</span>
											<div class="txt">{{customerInfor.vip_text}}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">总消费金额</span>
											<div class="txt">{{customerInfor.total_consume}}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">分成比例</span>
											<div class="txt">{{customerInfor.divide_ratio}}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box">
											<span class="lb_lt">上次登录时间</span>
											<div class="txt">{{customerInfor.last_login_time}}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<div class="box" style="display: initial;">
											<span class="lb_lt">备注</span>
											<div class="txt">
												<div class="val" v-if="!iSvalue">{{memo_input}}</div>
												<el-input @keyup.13.native="memoClick" v-if="iSvalue" v-model="memo_input" placeholder="请输入内容"></el-input>
											</div>
											<el-button plain style=" float: right; margin-top: 10px; margin-right: 20px;" @click="amend_btn" v-if="!iSvalue">修改</el-button>
											<el-button plain style=" float: right; margin-top: 10px; margin-right: 20px;" @click="confirm_btn" v-if="iSvalue">确定</el-button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { CustomerInfor, clientMemo, customerTop } from '../../common/api/http.js'
	export default{
		data(){
			return{
				customerInfor:'', // 客户详情
				iSvalue:false,
				memo_input:'',
				iStop:'',//是否置顶
				isshow:true,
			}
		},
		mounted() {
			
			// 客户详情
			let token = window.sessionStorage.getItem('token')
			let customerData = {
				'api_token':token,
				'customer_id':this.$route.query.customer_id
			}
			CustomerInfor(customerData).then(res => {
				// console.log(res)
				if(res.code == 0){
					this.customerInfor = res.data
					this.memo_input = res.data.memo
					
					// 是否置顶
					if(res.data.is_top=='1'){
						this.iStop = true
					}else{
						this.iStop = false
					}
					
					this.isshow = false //刷新后样式闪跳
					
				}else{
					this.$message.error(res.msg);
				}
				
			}).catch(err => {
				// console.log(err)
			})
			// 客户详情
		},
		methods:{
			// 备注修改
			amend_btn(e){
				this.iSvalue = true
			},
			// 备注确定
			confirm_btn(e){
				this.iSvalue = false
				this.memoData()
			},
			// 备注 - 回车
			memoClick(){
				this.iSvalue = false
				this.memoData()
			},
			//客户置顶
			clientTop(){
				let token = window.sessionStorage.getItem('token')
				let memoD = {
					'api_token':token,
					'customer_id':this.customerInfor.customer_id,
				}
				customerTop(memoD).then(res => {
					// console.log(res)
					if(res.code == 0){
						this.iStop = !this.iStop
					}else{
						this.$message.error(res.msg);
					}
					
				}).catch(err => {
					// console.log(err)
				})
			},
			// 备注提交
			memoData(){
				let token = window.sessionStorage.getItem('token')
				let memoD = {
					'api_token':token,
					'customer_id':this.customerInfor.customer_id,
					'memo':this.memo_input
				}
				clientMemo(memoD).then(res => {
					// console.log(res)
					if(res.code == 0){
						
					}else{
						this.$message.error(res.msg);
					}
					
				}).catch(err => {
					// console.log(err)
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.client_details_wrap {
		margin-top: 20px;
		.client_list_box {
			padding: 0 10px;
			.infor_box {
				width: 100%; height: 60px; border: 1px solid rgba(0,0,0,.125); border-radius: 4px; padding: 10px 20px; box-sizing: border-box;
				.img { width: 40px; height: 40px; border-radius: 50%; float: left;}
				.txt { font-size: 18px; color: #333; line-height: 40px; float: left; padding-left: 30px; border-left: 1px solid #f1f1f1; margin-left: 20px;}
			}
		}
		
		table.dataintable {
		    margin-top: 15px;
		    border-collapse: collapse;
		    border: 1px solid rgba(0, 0, 0, 0.125);
		    width: 100%;
			.tb_hd {
				height: 50px; background: #f1f1f1; text-align: right; line-height: 50px;
				span {
					margin-right: 20px; font-size: 16px; color: #333;
				}
			}
		}
		table.dataintable td {
		    vertical-align: text-top;
			padding: 0 0 0 20px;
		    border: 1px solid rgba(0, 0, 0, 0.125);
			.box {
				height: 60px; line-height: 60px;  display: flex; align-items: center;font-size: 16px; color: #333; 
				.lb_lt { float: left; width: 150px;}
				.hd_img { width: 40px; height: 40px; float: left; border-radius: 50%;}
				.txt { float: left;}
			}
		}
	}
</style>
